import $ from "jquery";

const companyFactsheet = {
    variables : {
        url : window.location.href,
    },
    methods : {
        dataLayerObj : function(el,e) {
            var obj = {
                'articleName' : "",
                'blogCategory' : "",
                'blogPageCategory' : "",
                'buttonText' : e ? e : "",
                'pageSection' : el ? el : "",
                'pageType' : document.querySelector("meta[name='template']").content == 'chli-base-page-template' ? companyFactsheet.variables.url.includes("blog") ? "Blogs" : companyFactsheet.variables.url.substring(companyFactsheet.variables.url.indexOf(".com/"), companyFactsheet.variables.url.lastIndexOf('/')  === ".com") && !companyFactsheet.variables.url.substring(companyFactsheet.variables.url.indexOf(".com/"), companyFactsheet.variables.url.length-1).includes('/') ? "Home" : "Other Pages" : "Blog Details Page",
                'planOption' : "",
                'productCategory' : "",
                'productName' : "",
                'question' : "",
                'searchTerm' : "",
                'videoTitle' : "",
                'bannerName' : "",
                'bannerType' : ""

            };
            return obj;
        },
        init : function(){
            $(".company__factsheet__cards").on('click', function(e){
                var title = $(".company__factsheet__title")[0].innerText.replace(/\n/g, '').trim();
                var buttonText = e.currentTarget.innerText.replace(/\n/g, '').trim();
                let obj = companyFactsheet.methods.dataLayerObj(title, buttonText);
                let flag = document.querySelector("input[name='pageType']") != null && (document.querySelector("input[name='pageType']").value == 'Product' || document.querySelector("input[name='pageType']").value == 'Category Page') ? true : false;
                if(flag){
                  createDataLayer('Download_Product',obj);
                }
                else{
                createDataLayer("Download_NonProduct", obj);
                }

            });
        }
    }

};

$(document).ready(function(){
    companyFactsheet.methods.init();
});

